import "core-js/modules/es.array.includes";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.search";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.url";
import _objectSpread from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import axios from '@/services/axios';
export var fetchABtest = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
    var key, did, uid, url, params, response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            key = _ref.key, did = _ref.did, uid = _ref.uid;
            url = '/rest/w/promotion/ab/getResult';
            params = {
              key: key
            };
            did && (params.did = did);
            uid && (params.uid = uid);
            _context.prev = 5;
            _context.next = 8;
            return axios.get(url, {
              params: params
            });

          case 8:
            response = _context.sent;

            if (!(response.result === 1)) {
              _context.next = 11;
              break;
            }

            return _context.abrupt("return", response.data);

          case 11:
            return _context.abrupt("return", false);

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](5);
            return _context.abrupt("return", false);

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 14]]);
  }));

  return function fetchABtest(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var pageMap = {
  '/activity/invite-share': 'inviteShare',
  '/activity/share-invitation': 'inviteShare',
  '/share/incentive/invitation': 'inviteShare',
  '/activity/boost-share-invitation': 'landing',
  '/activity/child-share-invitation': 'childShare',
  '/activity/sign-share': 'signShare'
};

var getPreivewMessage = function getPreivewMessage(name) {
  var search = new URLSearchParams(location.search);
  var sharePageType = search.get('sharePageType');
  var messageName = pageMap[name];
  var messageStr = decodeURIComponent(search.get(messageName));

  try {
    var message = JSON.parse(messageStr);
    var pageTypeNum = +sharePageType;

    if (message) {
      if (pageTypeNum && messageName === 'inviteShare') {
        message["experiment-".concat(pageTypeNum)] = _objectSpread({}, message);
      }

      return message;
    }

    return {};
  } catch (error) {
    return {};
  }
};

export var initPreviewPage = function initPreviewPage() {
  var messages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var previewPage = ['/activity/boost-share-invitation', '/activity/share-invitation', '/activity/invite-share', '/activity/child-share-invitation', '/activity/sign-share'];
  var previewMessage;

  if (previewPage.includes(location.pathname)) {
    previewMessage = getPreivewMessage(location.pathname);
    messages = Object.assign(messages, previewMessage);
  }

  var data = {};
  var key = pageMap[location.pathname];

  if (key) {
    data[key] = messages;
  }

  return data;
};